import { BannerModerationState } from 'store/models/moderation';

export const removeBannerFromState = (
    state: BannerModerationState,
    { campaignId, bannerId }: { campaignId: number; bannerId: number }
): BannerModerationState => {
    const campaignBanners = state.campaignModerationList.find(
        (campaign) => campaign.campaignId === campaignId
    )?.banners;
    const filteredCampaignBanners = campaignBanners?.filter((banner) => banner.bannerId !== bannerId);

    return {
        ...state,
        campaignModerationList: state.campaignModerationList
            .map((campaign) => {
                if (campaign.campaignId === campaignId) {
                    return {
                        ...campaign,
                        banners: filteredCampaignBanners || [],
                    };
                }
                return campaign;
            })
            .filter((campaign) => campaign.banners.length > 0),
    };
};
